import { Injectable } from "@angular/core";
import { New_ContactsState, New_ContactsStateService } from "./new_contacts.state.service";
import { New_ContactsRemote } from "../../infrastructure/new_contacts.remote";
import { switchMap, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { Contact } from "@models";

@Injectable({
	providedIn: "root"
})
export class New_ContactsFacade {
	constructor(
		private readonly contactsStateService: New_ContactsStateService,
		private readonly contactsRemote: New_ContactsRemote
	) {}

	public getContacts(): Observable<New_ContactsState> {
		if (!this.contactsStateService.areContactsLoaded()) {
			return this.contactsRemote.getContacts().pipe(
				tap((contacts: []) => {
					this.contactsStateService.setContacts(contacts);
				}),
				switchMap(() => this.contactsStateService.getContacts())
			);
		}

		return this.contactsStateService.getContacts();
	}

	public addNewContact(contact): void {
		this.contactsStateService.addContact(contact);
	}

	public reloadContacts(): Observable<New_ContactsState> {
		this.contactsStateService.reloadContacts();
		return this.getContacts();
	}

	public updateContacts(contacts: Contact[]): void {
		this.contactsStateService.setContacts(contacts);
	}
}
